import {useEffect, useState} from 'react'
import CartFilter from '../../common/components/CartFilter.js'
import handleListSelection from '../../common/handleListSelection.js'
import {useSelector} from '../../store.js'
import {setCartFilters} from './analyticsActions.js'
import {cartFiltersSelector} from './analyticsSelectors.js'
import {FILTER_SELECT_ALL} from '../../common/components/FilterDropdown.js'

export async function handleAnalyticsCartListSelection({
  option,
  event,
  list,
  selectedIDs,
  setSelectedIDs,
  lastSelectedID,
  setLastSelectedID,
}) {
  list = list
    .filter(({type}) => type !== FILTER_SELECT_ALL)
    .map(({entity: {id}}) => id)

  if (option.type === FILTER_SELECT_ALL) {
    setSelectedIDs(selectedIDs.length === list.length ? [] : list)

    return
  }

  const cartID = option.entity.id

  setSelectedIDs(
    handleListSelection({
      value: cartID,
      isSelected: event ? event.target.checked : !selectedIDs.includes(cartID),
      isShiftKey: event?.shiftKey,
      selected: selectedIDs,
      list,
      previousValue: lastSelectedID,
    }),
  )

  setLastSelectedID(cartID)
}

export default function AnalyticsCartFilter() {
  const cartFilters = useSelector(cartFiltersSelector)
  const [selectedIDs, setSelectedIDs] = useState([])
  const [lastSelectedID, setLastSelectedID] = useState(null)

  useEffect(() => {
    setSelectedIDs(cartFilters)
  }, [cartFilters])

  return (
    <CartFilter
      label="Filter by Sales Channel"
      dropdown="analytics_cart_filter"
      value={selectedIDs}
      onSelect={(option, event, list) =>
        handleAnalyticsCartListSelection({
          option,
          event,
          list,
          selectedIDs,
          setSelectedIDs,
          lastSelectedID,
          setLastSelectedID,
        })
      }
      onChange={() => setCartFilters(selectedIDs)}
      includeSelectAll
    />
  )
}
